<template>
  <div class="">
    <h1 v-if="!onlyCheckout">Checkout Area</h1>
    <div v-if="!onlyCheckout" class="checkout-area">
      <span> {{ cartTotalProduct }} </span><i class="fa fa-shopping-cart"></i>
      <table>
        <thead>
          <tr>
            <th class="align-center">SL</th>
            <th>Name</th>
            <th>Description</th>
            <th class="align-right">Amount</th>
            <th class="align-right">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, idx) in cart" :key="idx">
            <td class="align-center">{{ idx + 1 }}</td>
            <td>{{ product.title }}</td>
            <td>{{ product.description }}</td>
            <td class="align-right">{{ cart[idx].quantity }}</td>
            <td class="align-right">{{ product.price | currency }}</td>
            <button @click="removeProduct(product)"> X </button>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="align-right">Subtotal:</td>
            <td class="align-right"><h4 v-if="cartSubTotal != 0"> {{ cartSubTotal | currency }} </h4></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="align-right">Shipping:</td>
            <td class="align-right"><h4 v-if="cartSubTotal != 0"> {{ shippingTotal | currency }} </h4></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="align-right vert-bottom">Total:</td>
            <td class="align-right vert-bottom"><h2 v-if="cartSubTotal != 0"> {{ cartTotal | currency }} </h2></td>
          </tr>
        </tbody>
      </table>
      <button v-show="cartSubTotal" @click="openModal">Checkout</button>
    </div>
    <checkout-details v-if="showModal" :cart="cart" :cart-sub-total="cartSubTotal" :shipping-total="shippingTotal" :cart-total="cartTotal" />
  </div>
</template>

<script>
  import {bus} from '../main';
  import CheckoutDetail from './CheckoutDetail';

  export default {
    name: "Checkout",
    components: {
      'checkout-details': CheckoutDetail,
    },
    props: ['cart', 'cartTotalProduct', 'cartSubTotal', 'recipientName', 'phone', 'onlyCheckout', 'showModal'],

    computed: {
      shippingTotal: function() {
        let shippingTotal = 0;
        this.cart.forEach(product => {
          shippingTotal += product.shipping_charge * product.quantity;
        });
        return shippingTotal;
      },
      cartTotal: function() {
        return this.cartSubTotal + this.shippingTotal;
      },
    },

    filters: {
      currency: function(price){
        return '$' + price;
      }
    },

    methods: {
      openModal: function() {
        bus.$emit('openCheckoutModal');
      },
      removeProduct: function(product) {
        var idx = this.cart.indexOf(product);
        bus.$emit('prodRemove', idx);
      },
    },
  }

</script>

<style scope>
  
</style>